import PropTypes from "prop-types";

import ArrowUpGreen from "assets/svg/arrow_up_green.svg";

import Datef from "components/common/date-format";
import Price from "components/common/price";

import styles from "./styles.module.css";

const PreviousPriceTable = ({ priceHistory }) => {
  return (
    <table className={styles.tableWrapper}>
      <thead>
        <tr className={styles.titles}>
          <th>Tarih</th>
          <th>Durum</th>
          <th>Fiyat</th>
        </tr>
      </thead>
      <tbody>
        {priceHistory?.map((item, index) => (
          <tr className={styles.info} key={index}>
            <th className={styles.dateClass}>
              <Datef format="DD.MM.YYYY" value={item?.changedAt} />
            </th>

            <th className={styles.statusClass}>
              {index === 0 ? "Son Fiyat" : index === priceHistory?.length - 1 && "İlk Fiyat"}
            </th>
            <th className={styles.priceClass}>
              <span className={styles.iconWrapper}>
                {item.trend === "up" && (
                  <div className={styles.upArrow}>
                    <ArrowUpGreen />
                  </div>
                )}

                {item.trend === "down" && (
                  <div className={styles.downArrow}>
                    <ArrowUpGreen />
                  </div>
                )}
              </span>
              <Price price={item?.price} currency={item?.currency} />
            </th>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

PreviousPriceTable.propTypes = {
  priceHistory: PropTypes.array,
};

export default PreviousPriceTable;
